window.addEventListener('load', function () {

  let selectedProducts = new Set(); 
  const maxAdditionalItems = 4; // 2, 3, 4, 5 tak jaane ke liye 4 steps hain

  function getMainQty() {
    const qtyInput = document.querySelector('input[name="quantity"]');
    return qtyInput ? parseInt(qtyInput.value) : 1;
  }

  function updateNudgeText(additionalCount){
    let nudge = document.querySelector('.bmsm-nudge-text');
    if(!nudge) return;
    
    let text = '';
    // additionalCount = 0 ka matlab sirf 1 main product hai
    if(additionalCount === 0)      text = "Add 1 more item to get 5% OFF + Free Shipping 🤩";
    else if(additionalCount === 1) text = "Buy 1 more to get 10% OFF 🤩";
    else if(additionalCount === 2) text = "Buy 1 more to get 15% OFF 🤩";
    else if(additionalCount === 3) text = "Buy 1 more to get 20% OFF 🤩";
    else if(additionalCount >= 4)  text = "🎉 All rewards unlocked!";
    
    nudge.innerText = text;
  }

  function updateProgress() {
    let bundleCount = selectedProducts.size;
    let mainQty = getMainQty();
    
    // 🔥 FIX: Default 0 karne ke liye total mein se 1 minus kiya
    // Taake agar sirf 1 product ho toh (1-1) = 0 progress dikhaye
    let additionalItemsCount = (mainQty + bundleCount) - 1;
    
    // Progress percentage (Max 4 steps hain: 2, 3, 4, 5 items ke liye)
    let percent = (Math.min(additionalItemsCount, maxAdditionalItems) / maxAdditionalItems) * 100;
    
    let bar = document.querySelector('.bmsm-progress-indicator');
    if(bar) { 
        bar.style.width = percent + '%'; 
        bar.style.display = 'block'; 
    }

    updateNudgeText(additionalItemsCount);

    // Achievement text tab dikhayein jab kam az kam 1 extra item add ho jaye
    let achievement = document.querySelector('.bmsm-achievement-text');
    if(achievement) achievement.style.display = additionalItemsCount >= 1 ? 'block' : 'none';
  }

  // Quantity change detect karne ke liye
  document.addEventListener('click', function(e) {
    if (e.target.closest('.qtyBtn') || e.target.closest('.qty-btn') || e.target.closest('.minus') || e.target.closest('.plus')) {
        setTimeout(updateProgress, 100); 
    }
  });

  document.addEventListener('input', function(e) {
    if (e.target.name === 'quantity') {
        updateProgress();
    }
  });

  // Bundle Add/Remove logic
  document.addEventListener('click', function(e){
    let btn = e.target.closest('.discount-badge');
    if(!btn) return;
    
    let card = btn.closest('.bundle-card');
    let variantSelect = card ? card.querySelector('.bundle-variant-select') : null;
    if(!variantSelect) return;
    let variantId = variantSelect.value;

    if(selectedProducts.has(variantId)){
      selectedProducts.delete(variantId);
      btn.innerText = 'ADD';
      btn.style.background = '#000000';
      variantSelect.disabled = false;
    } else {
      let currentTotal = selectedProducts.size + getMainQty();
      if(currentTotal < 5) { // Total 5 items ki limit (Main + 4 extras)
          selectedProducts.add(variantId);
          btn.innerText = 'REMOVE';
          btn.style.background = '#ff0101';
          variantSelect.disabled = true;
      } else {
          alert("Maximum limit of 5 items reached!");
      }
    }
    updateProgress();
  });

  // Form Submission (Pehle wala logic same rahega)
  const mainForm = document.querySelector('form[action="/cart/add"], form[data-type="add-to-cart-form"]');
  if(mainForm){
    mainForm.addEventListener('submit', function(e){
      if(selectedProducts.size > 0){
        e.preventDefault();
        e.stopImmediatePropagation(); 

        const submitBtn = mainForm.querySelector('[type="submit"], .add-to-cart-btn');
        if(submitBtn) { submitBtn.innerText = "Adding..."; submitBtn.disabled = true; }

        let bundleForm = document.createElement('form');
        bundleForm.method = 'POST';
        bundleForm.action = '/cart/add';
        bundleForm.style.display = 'none';

        const mainId = mainForm.querySelector('[name="id"]').value;
        const mainQty = mainForm.querySelector('[name="quantity"]')?.value || 1;

        // Add Main Product
        let inputMainId = document.createElement('input');
        inputMainId.name = 'items[0][id]'; inputMainId.value = mainId;
        bundleForm.appendChild(inputMainId);

        let inputMainQty = document.createElement('input');
        inputMainQty.name = 'items[0][quantity]'; inputMainQty.value = mainQty;
        bundleForm.appendChild(inputMainQty);

        // Add Bundle Products
        let index = 1;
        selectedProducts.forEach(vId => {
          let idInp = document.createElement('input');
          idInp.name = `items[${index}][id]`; idInp.value = vId;
          bundleForm.appendChild(idInp);

          let qtyInp = document.createElement('input');
          qtyInp.name = `items[${index}][quantity]`; qtyInp.value = 1;
          bundleForm.appendChild(qtyInp);
          index++;
        });

        let returnTo = document.createElement('input');
        returnTo.name = 'return_to'; returnTo.value = '/cart';
        bundleForm.appendChild(returnTo);

        document.body.appendChild(bundleForm);
        bundleForm.submit();
      }
    }, true); 
  }

  // Initial Run
  updateProgress();
});